import React, { useEffect, useState } from "react";
import styles from "../Dashoard.module.css";
import CourseImg from "../../../assets/imgs/Session-img.png";
import Button from "@mui/material/Button";
import CoursesCard from "../../CoursesCard/CoursesCard";
import EmptyCard from "../../EmptyCard/EmptyCard";
import { InfoIcon } from "../../../assets/icons/InfoIcon";

const RecentCourses = (props) => {
  const { lastTwoRecentCourses } = props;

  const [sessionData, setSessionData] = useState([]);

  useEffect(() => {
    if (lastTwoRecentCourses?.length > 0) {
      let newData = [];

      lastTwoRecentCourses?.map((singleCourse, index) =>
        newData.push({
          img: singleCourse?.course?.courseImage,
          date: "Sun, Mar 13",
          price:
            singleCourse?.course?.price > 0
              ? singleCourse?.course?.price
              : "Free",
          title: singleCourse?.course?.courseTitle,
          link: `course-details/${singleCourse?.course?.courseId}`,
          tracklabel: singleCourse?.course?.courseTitle,
          actionButton: true,
          actionButtonLabel: "Go To Course",

          chipLabel: "In Progress",
          chipBackground: "rgba(114, 102, 251, 0.12)",
          chipcolor: "#7266FB",
        })
      );
      setSessionData(newData);
    }
  }, [lastTwoRecentCourses]);

  return (
    <>
      <div className={styles.CardSection}>
        <div className={styles.CardSectionTitle}>
          Recent Courses
          {/* <Button className={styles.SeaAllButton} variant="text">See all</Button> */}
        </div>
        {sessionData?.length > 0 && (
          <CoursesCard sessionData={sessionData} col={6} TrackSection={false} />
        )}

        {sessionData?.length == 0 && (
          <EmptyCard
            Icon={<InfoIcon />}
            description="You do not have any recent courses."
            showButton={false}
            btnLabel="Explore Courses"
            btnLink="/search"
          />
        )}
      </div>
    </>
  );
};

export default RecentCourses;
